import sch from "@stanfordchildrens/sch-client"
import "@stanfordchildrens/sch-client/ts/behaviors/navbar-minify"

import "../scss/tpn"
import "../img/tpn.svg"

sch.config({
   application: "TPNCalc",
   pwa: true,
   env: location.hostname.indexOf("cdsdev") < 0 ? "prd" : "dev"
})

const tpn = {

   init() {
      document.getElementById("CDS-Logo")!.removeAttribute("target");

      (document.getElementById("tpnForm") as HTMLFormElement).reset()

      document.getElementById("tpnForm")!.addEventListener("submit", (e: SubmitEvent) => {
         e.preventDefault()
         this.cycle()
         document.getElementById("result")!.classList.remove("closed")
      }, false)
   },

   cycle() {
      var
         v = parseFloat((document.getElementById("v") as HTMLInputElement).value),
         t = parseFloat((document.getElementById("t") as HTMLInputElement).value),
         c1 = v / ((4 * t) - 10),
         c2 = 2 * c1,
         c4 = 4 * c1

      document.getElementById("c1")!.textContent = (Math.round(c1 * 10) / 10) as unknown as string
      document.getElementById("c2")!.textContent = (Math.round(c2 * 10) / 10) as unknown as string
      document.getElementById("c4")!.textContent = (Math.round(c4 * 10) / 10) as unknown as string
      document.getElementById("h4")!.textContent = (Math.round(t * 10) / 10) as unknown as string
      document.getElementById("h5")!.textContent = (Math.round((t - 1) * 10) / 10) as unknown as string
      document.getElementById("h6")!.textContent = (Math.round((t - 2) * 10) / 10) as unknown as string
   }

}

document.addEventListener('DOMContentLoaded', () => {
   tpn.init()
}, false)
